import React from "react";
import Layout from "@/components/layout";
import HeaderOne from "@/components/header-one";
import MenuContextProvider from "@/context/menu-context";
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import AboutFour from "@/components/about-four";
// import VideoOne from "@/components/video-one";
// import TestimonialsOne from "@/components/testimonials-one";
// import TeamOne from "@/components/team-one";
import AboutMissonAndVision from "@/components/about-mission-vision"
import SponsorOne from "@/components/sponsor-one";
import AboutWhyChooseUs from "@/components/about-why-choose-us";
import AboutDirector from "@/components/about-director";
import AboutOurPolicy from "@/components/about-our-policy";

const About = () => {
  return (
    <MenuContextProvider>
      <Layout PageTitle="About Page">
        <HeaderOne />
        <PageHeader title="About Us" name="About" />
        <AboutFour />
        <AboutDirector />
        <AboutWhyChooseUs />
        <AboutOurPolicy />
        <AboutMissonAndVision />
        <SponsorOne />
        <Footer />
      </Layout>
    </MenuContextProvider>
  );
};

export default About;
